export default __webpack_public_path__ + "static/media/main_info_data_05.c9a38841.png";